const ROLE_ADMIN_2 = 9;

export default {
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },

    isAdmin2() {
      const { user } = this.$store.state.user;
      return user?.settings?.role_id === ROLE_ADMIN_2;
    },
  },
};
